import template from './helloPackModal.html';
import controller from './helloPackModalCtrl';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    clientId: '<?',
    isForLoanWriters: '<',
    selectedService: '<',
    onlyFactFind: '<?',
    loanApplicationId: '<?',
    insuranceProfilerId: '<?',
    inviteInsuranceOnlineFactFind: '<?',
    hideDealOption: '<?',
    custom: '<?',
  },
};
